import useInspireOptions from '../../../hooks/useInspireOptions';
import { useProfiles } from '../../hooks/useProfiles';

const useTmAlias = (): string => {
  const { isTm } = useInspireOptions();
  const { loggedInProfile } = useProfiles();

  const tmAlias = isTm
    ? loggedInProfile?.user?.alias
    : loggedInProfile?.managers[0]?.alias;

  return tmAlias ?? '';
};

export default useTmAlias;
